module.exports = __webpack_public_path__ + "static/statesman_sec5-844d3ef609d53a497800fc1222f837b3.png";